import { render, staticRenderFns } from "./clubs.vue?vue&type=template&id=6c463c15&"
import script from "./clubs.vue?vue&type=script&lang=ts&"
export * from "./clubs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports